import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

// GET /api/vehicles — paginated list (params: page, limit, search, sortBy, sortOrder)
export const getVehiclesApi = (params = {}) => {
  return axios.get(`${API_BASE_URL}/api/vehicles`, { params });
};

// POST /api/vehicle/create
export const createVehicleApi = (data) => {
  return axios.post(`${API_BASE_URL}/api/vehicle/create`, data);
};

// POST /api/vehicle/update  (super-admin only; body must include _id)
export const updateVehicleApi = (data) => {
  return axios.post(`${API_BASE_URL}/api/vehicle/update`, data);
};

// DELETE /api/vehicle/delete/:id  (super-admin only)
export const deleteVehicleApi = (id) => {
  return axios.delete(`${API_BASE_URL}/api/vehicle/delete/${id}`);
};

// PATCH /api/vehicle/:id/status
export const toggleVehicleStatusApi = (id, status) => {
  return axios.patch(`${API_BASE_URL}/api/vehicle/${id}/status`, { status });
};

// POST /api/vehicle/:id/assign  — body: { employeeId, kilometers? }
export const assignVehicleApi = (vehicleId, data) => {
  return axios.post(`${API_BASE_URL}/api/vehicle/${vehicleId}/assign`, data);
};
